import React, { useContext, useState } from 'react'
import { StoreContext } from 'contexts/StoreContext'
import { getTranslatedTextByKey } from 'utils/utils'
import { onStartOrderClick } from 'utils/storeLocatorUtils'

import styled from 'styled-components'
import ButtonBase from 'components/common/ButtonBase'
import type { ORDER_TYPES } from 'utils/constants'
import type _User from 'mobx/User'
import type _Infra from 'mobx/Infra'
import { useRouter } from 'next/router'
import { useStores } from 'hooks/useStores'

const StyledChildrenButton = styled(ButtonBase)`
	width: 242px;
	margin: 10px 0;
`

interface PopupButtonProps {
	btnText: string
	orderType: typeof ORDER_TYPES[keyof typeof ORDER_TYPES]
	store: any
	params: any
}

const PopupButton = (props: PopupButtonProps) => {
	const [isLoading, setIsLoading] = useState(false)
	const { setStore } = useContext(StoreContext) || {}
	const { cartStore, addressManagerV2Store } = useStores()
	const router = useRouter()

	return (
		<StyledChildrenButton
			// @ts-ignore
			$type="secondary"
			id={`children_button_${props.btnText}`}
			disabled={isLoading}
			onClick={() =>
				onStartOrderClick({
					orderType: props.orderType,
					setIsLoading,
					latLng: props.store.address.latLng,
					store: props.store,
					params: props.params,
					router,
					setStore,
					cartStore,
					addressManagerV2Store
				})
			}
			data-testid={`store-locator-start-order-${props.orderType}`}
			key={props.orderType}
		>
			{!isLoading && <> {props.btnText} </>}
			{isLoading && <> {getTranslatedTextByKey('eCommerce.storeLocator.loading', 'Loading...')} </>}
		</StyledChildrenButton>
	)
}

export default PopupButton
